import { getApplicantStatusLabel } from "data/applicant-statuses";

// Custom filter method for status filtering that handles value-to-label conversion
const statusFilterMethod = (filter, row) => {
    const { value } = filter;
    if (!value) return true;

    const cellValue = row[filter.id];
    if (cellValue === null || cellValue === undefined) return false;

    // Convert the cell value to its label and compare with the filter value
    const cellLabel = getApplicantStatusLabel(cellValue);
    return cellLabel === value;
};

export default statusFilterMethod;
